import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  RealtimeDataTagsBody,
  SvgFileMetadataCreate,
  SvgFileMetadataList,
  SvgFilesMetadataUpdate,
  SvgNodeList,
  TagsRealtimeData
} from 'src/swagger-gen/web-secured/models';
import { BaseService } from '../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SvgRepo extends BaseService {
  svgUrl = environment.apiUrl + '/stations' ;

  constructor(private http: HttpClient, private logger: NGXLogger) {
    super();
  }

  getStationSVGFilesMetadata(stationUid: string): Observable<SvgFileMetadataList> {
    const url = `${this.svgUrl}/${stationUid}/svg`;

    const httpOptions = {
      headers: this.httpHeaders()
    };

    return this.http.get<SvgFileMetadataList>(url, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  updateStationSVGMetadata(stationUid: string, body: SvgFilesMetadataUpdate): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg`;

    const httpOptions = {
      headers: this.httpHeaders()
    };

    return this.http.put<any[]>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  createStationSVGMetadata(stationUid: string, body: SvgFileMetadataCreate): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg`;

    const httpOptions: any = {
      headers: this.httpHeaders(),
      observe: 'response'
    };

    return this.http.post<any>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  updateSVGAssociation(stationUid: string, synopticUid: string, body: SvgFileMetadataCreate): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg/${synopticUid}`;

    const httpOptions: any = {
      headers: this.httpHeaders(),
      observe: 'response'
    };

    return this.http.put<any>(url, body, httpOptions).pipe(
      catchError(this.handleServerError)
    );
  }

  getStationSVGFile(stationUid: string, svgFileUid: string): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg/${svgFileUid}/file`;

    return this.http.get<any>(url, {responseType: 'text' as 'json'}).pipe(
      catchError(this.handleServerError)
    );
  }

  associateStationSVGFile(stationUid: string, svgFileUid: string, body: File): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg/${svgFileUid}/file`;

    return this.http.post<any>(url, body, {responseType: 'blob' as 'json', observe: 'response'}).pipe(
      catchError(this.handleServerError)
    );
  }

  getSVGTags(stationUid: string, synopticUid: string): Observable<SvgNodeList> {
    const url = `${this.svgUrl}/${stationUid}/svg/${synopticUid}/tags`;
    const httpOptions = {
        headers: this.httpHeaders(),
    };

    return this.http.get<SvgNodeList>(url, httpOptions).pipe(
        catchError(this.handleServerError)
    );
  }

  getTagsRealtimeData(body: RealtimeDataTagsBody): Observable<TagsRealtimeData> {
    const url = environment.apiUrl + `/tags/realtime`;
    const httpOptions = {
        headers: this.httpHeaders(),
    };

    return this.http.post<TagsRealtimeData>(url, body, httpOptions).pipe(
        catchError(this.handleServerError)
    );
  }

  deleteSvg(stationUid: string, synopticUid: string): Observable<any> {
    const url = `${this.svgUrl}/${stationUid}/svg/${synopticUid}`;

    const httpOptions = {
      headers: this.httpHeaders(),
    };

    return this.http.delete<any>(url, httpOptions).pipe(
    catchError(this.handleServerError)
  );
  }
}
